﻿import { Component, Inject, OnInit, Injectable, enableProdMode } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd, NavigationCancel } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AppConstants } from './_helpers/app.constants';
import { MenuSettingsService } from './_layout/settings/menu-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { MainService } from './_services/main.service';
import { environment } from 'src/environments/environment';
import { TranslatorService } from './_services/translator.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-main',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.css']
})
@Injectable()
export class AppComponent implements OnInit {
  public _menuSettingsConfig: any;
  public _unsubscribeAll: Subject<any>;
  private _unsubscribeAllMenu: Subject<any>;
  showContent = false;
  public title;
  lineLift = true;
  constructor(private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public loader: LoadingBarService,
    private deviceService: DeviceDetectorService,
    public _menuSettingsService: MenuSettingsService,
    private titleService: Title,
    private mainService: MainService,
    private translate: TranslatorService,
    private pusherService: PusherService,
    private toastr: ToastrService,
    private line: LineGuard
  ) {
    this._unsubscribeAll = new Subject();
    this._unsubscribeAllMenu = new Subject();
    this.setTitle();
    this.lineLift = this.line.states.userLineID != '';
  }
  ngOnInit() {
    if (environment.production) {
      // enableProdMode();
      if (window) {
        window.console.log = function () { };
      }
      console.log = function () { };
    }
    flatpickrFactory();
    this._menuSettingsService.config
      .pipe(takeUntil(this._unsubscribeAllMenu))
      .subscribe((config) => {
        this._menuSettingsConfig = config;
      });
    // page progress bar percentage
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // set page progress bar loading to start on NavigationStart event router
        this.loader.start();
      }
      if (event instanceof RouteConfigLoadStart) {
        this.loader.increment(35);
      }
      if (event instanceof RouteConfigLoadEnd) {
        this.loader.increment(75);
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // set page progress bar loading to end on NavigationEnd event router
        this.loader.complete();
        this.showContent = true;
        // close menu for mobile view
        if (this.deviceService.isMobile() || window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH) {
          if (document.body.classList.contains('menu-open')) {
            document.body.classList.remove('menu-open');
            document.body.classList.add('menu-close');
          }
        }
      }
    });
    this.mainService.doGetSchoolInFo().then(data => {
      localStorage.setItem(environment.SchoolInFo, JSON.stringify(data));
    });
    this.pusherService
      .getFeedItems()
      .subscribe((data) => {
        let datas = JSON.parse(data);
        this.toastr.info(datas.description, datas.title,
          {
            timeOut: 5000,
            extendedTimeOut: 1000,
            closeButton: true,
          }
        );
      });
  }

  setTitle() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
          if (!this._menuSettingsConfig.vertical_menu.items[i].submenu &&
            this._menuSettingsConfig.vertical_menu.items[i].page === this.router.url) {
            this.title = this._menuSettingsConfig.vertical_menu.items[i].title;
            break;
          } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu) {
            // Level 1 menu
            for (let j = 0; j < this._menuSettingsConfig.vertical_menu.items[i].submenu.items.length; j++) {
              if (!this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu &&
                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === this.router.url) {
                this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].title;
                break;
              } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu) {
                // Level 2 menu
                for (let k = 0; k < this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items.length; k++) {
                  if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].page === this.router.url) {
                    this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].title;
                  }
                }
              }
            }
          }
        }
        this.title = this.translate.translate(this.title);
        if (this.title && this.router.url !== '/') {
          this.titleService.setTitle(this.title + '- สรรหามาเล่า');
        } else {
          if (this.router.url === '/') {
            this.title = 'เข้าสู่ระบบ สรรหามาเล่า';
            this.titleService.setTitle(this.title + '- สรรหามาเล่า');
            this.title = '';
          } else if (this.router.url === '/login') {
            this.title = 'เข้าสู่ระบบ สรรหามาเล่า';
            this.titleService.setTitle(this.title + '- สรรหามาเล่า');
            this.title = '';
          } else if (this.router.url === '/register') {
            this.title = 'ลงทะเบียน สรรหามาเล่า';
            this.titleService.setTitle(this.title + '- สรรหามาเล่า');
            this.title = '';
          }
        }

      }
    });
  }
}
import flatpickr from 'flatpickr';
import { Thai } from 'flatpickr/dist/l10n/th';
import { PusherService } from './_services/pusher.service';
import { LineGuard } from './_guards/line.guard';
export function flatpickrFactory() {
  flatpickr.localize(Thai);
  return flatpickr;
}